<bsolve-app-card
  [title]="'SUBSCRIPTION CONFIRMATION'"
  [isLoading]="loading"
  [loadingText]="'Loading list of accounts...'"
  [icon]="'../../../assets/img/icon/accept.png'"
  [showCloseIcon]="false"
>
<form [formGroup]="activatedFormGroup" *ngIf="activatedFormGroup">
  <div>Thank you for your purchase</div>
  <div>Plan: {{PlanType}}</div>
  <div>Tenant size: {{PlanSize}}</div>
  <div>Your one-time paymnet has been received and your subscription will be active from today until {{ExpiryDate}}</div>
  <div>Please select the tenant to activate</div>

<bsolve-select 
                formControlName="tenantDropdown"
                [optionID]="'id'"
                [optionLabel]="'name'"
                [options]="tenants"
                [width]="'250px'"
                >
                </bsolve-select>
<br />
<br />
  <div>Don't see your tenant listed? The dropdown displays tenants linked to the SProbot account owned by you. <a href=''>Sign in with a different user</a></div>
  <br />
  <div>If you haven't connected to a tenant yet, please <a href=''>get in touch</a> for assistance</div>
</form>
</bsolve-app-card>

  <button (click)="activateLicence()" class="primary m-top">
          Activate
  </button>